import { TimelineMax } from 'gsap';
import { Pausable } from '../../Utils/Pausable';

export class Animation extends Pausable {
    public get time() {
        return this.timeLine.time();
    }

    public set time(time: number) {
        this.seek(time);
    }

    public get timeScale() {
        return this.timeLine.timeScale();
    }

    public set timeScale(value: number) {
        this.timeLine.timeScale(value);
    }

    public playPromise: Promise<void>;
    protected readonly timeLine: TimelineMax;
    private playing: boolean;
    private readonly pauseWithGame: boolean;
    private playResolve: VoidFunction;

    constructor({
        repeat = 0,
        pauseWithGame = false,
    }: { repeat?: number; pauseWithGame?: boolean } = {}) {
        super();
        this.timeLine = new TimelineMax({ repeat });
        this.timeLine.addLabel('start', '+=0');
        this.pauseWithGame = pauseWithGame;
        this.pause(0, true);
    }

    public add(value: any, position?: string, useLastLabel?: boolean) {
        const timeLine = this.timeLine;
        if (!useLastLabel) {
            const labelName = Math.random().toString();
            timeLine.addLabel(labelName, timeLine.duration());
        }
        timeLine.add(value, position);
    }

    public addToLast(value: any, position?: string) {
        const timeline = this.timeLine;
        const lastLabel = timeline.getLabelBefore(timeline.duration() + 0.01);
        this.add(value, lastLabel, true);
    }

    public addDelay(delayMs: number) {
        this.timeLine.set({}, {}, '+=' + delayMs / 1000);
    }

    public play(): Promise<void> {
        this.addListeners();
        this.seek(0);
        this.playing = true;
        if (!this.pauseWithGame || !Animation.isPaused) {
            this.timeLine.play();
        }
        if (!this.playPromise) {
            this.playPromise = new Promise(resolve => {
                this.playResolve = resolve;
                this.timeLine.eventCallback('onComplete', () => {
                    this.destroy();
                    resolve();
                    this.playPromise = null;
                });
            });
        }
        return this.playPromise;
    }

    public pause(atTime: string | number = '+=0', suppressEvents: boolean = false) {
        this.playing = false;
        this.timeLine.pause(atTime, suppressEvents);
    }

    public resume(from?: any, suppressEvents?: boolean) {
        this.playing = true;
        this.timeLine.resume(from, suppressEvents);
    }

    public seek(position: string | number, suppressEvents: boolean = false) {
        this.timeLine.seek(position, suppressEvents);
    }

    public reversed(): Promise<void> {
        this.timeLine.reverse();
        return new Promise(resolve => {
            this.timeLine.eventCallback('onReverseComplete', () => {
                resolve();
            });
        });
    }

    public kill(vars: {} = null, target: {} = null) {
        this.timeLine.kill(vars, target);
        if (this.playResolve) {
            this.playResolve();
        }
    }

    public destroy() {
        this.kill();
        super.destroy();
    }

    protected setPaused(paused: boolean): void {
        if (!this.pauseWithGame) {
            return;
        }
        if (paused) {
            this.timeLine.pause();
        } else if (this.playing) {
            this.timeLine.play();
        }
    }
}
